import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { BsImage } from "react-icons/bs";
import { FaChevronLeft } from "react-icons/fa";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import toast from "react-hot-toast";


export function ModalAddSeller({ setShow, apiGetUser }) {
  const [type, setType] = useState(null); 
  const [step, setStep] = useState(1);

  const [loadingCreate, setLoadingCreate] = useState(false);

  const [openImmigration, setOpenImmigration] = useState(false);
  const [openTrType, setOpenTrType] = useState(false);

  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [birthday, setBirthday] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");

  const [immigrationStatus, setImmigrationStatusValue] = useState("");
  const [trType, setTrType] = useState("");
  const [immigrationStatusList, setImmigrationStatusList] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(false);

  const immigrationDocRef = useRef(null);
  const [documentName, setDocumentName] = useState("");
  const [immigrationDocument, setImmigrationDocument] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const [errors, setErrors] = useState({});

  const trTypeList = Object.values(immigrationStatusList.Temporary || {});

  const mainStatusList = [
    { key: "TEMPORARY", value: "temporary", label: "Temporary Resident" },
    ...Object.entries(immigrationStatusList)
      .filter(([key]) => key !== "Temporary")
      .map(([, val]) => val),
  ];

  useEffect(() => {
    setLoadingStatus(true);
    apiRequests
      .get("/api/seller/v1/get-ImmigrationStatus")
      .then((res) => setImmigrationStatusList(res.data.data || {}))
      .catch(() => toast.error("Failed to load immigration statuses"))
      .finally(() => setLoadingStatus(false));
  }, []);

  function uploadImage(file) {
    setUploadingImage(true);

    const formData = new FormData();
    formData.append("file", file);

    apiRequests
      .post("/api/file/v1/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.success) {
          setImmigrationDocument(res.data.message._id);
          toast.success("Document uploaded successfully");
        }
      })
      .catch(() => toast.error("Failed to upload document"))
      .finally(() => setUploadingImage(false));
  }

  function validateStep1() {
    const newErrors = {};

    if (!userName.trim()) newErrors.userName = true;
    if (!mobile.trim()) newErrors.mobile = true;
    if (!email.trim()) newErrors.email = true;
    if (!address.trim()) newErrors.address = true;
    if (!birthday) newErrors.birthday = true;
    if (!password) newErrors.password = true;

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill in all required fields correctly");
      return false;
    }
    return true;
  }

  function validateStep2() {
    const newErrors = {};

    if (!immigrationStatus) newErrors.immigrationStatus = true;
    if (immigrationStatus === "temporary" && !trType) newErrors.trType = true;
    if (!immigrationDocument) newErrors.immigrationDocument = true;
    if (!/^\d{16}$/.test(bankAccountNumber))
      newErrors.bankAccountNumber = true;

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill in all required fields correctly");
      return false;
    }
    return true;
  }

  function CreateUser() {
    if (!validateStep2()) return;

    setLoadingCreate(true);

    const data = {
      userName,
      email,
      address,
      password,
      mobile,
      birthday,
      immigrationStatus:
        immigrationStatus === "temporary" ? trType : immigrationStatus,
      immigrationDocument,
      bankAccountNumber,
    };

  
    const endpoint =
      type === "Chef"
        ? "/api/seller/v1/register-chef"
        : "/api/seller/v1/register-seller";

    apiRequests
      .post(endpoint, data)
      .then((res) => {
        toast.success(res.data.en_message);
        setShow(false);
        apiGetUser();
      })
      .catch(() => {})
      .finally(() => setLoadingCreate(false));
  }

  function goBack() {
    if (step === 2) {
      setStep(1);
    } else {
      setType(null);
    }
  }

  return (
    <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
      <div className="flex min-h-full items-center justify-center p-3">
        <div className="modal relative text-black transform rounded-2xl shadow-2xl bg-white w-full max-w-xl max-h-[88vh] flex flex-col">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0">
            {type === null ? (
              <span className="w-6" />
            ) : (
              <button
                className="text-gray-500 hover:text-gray-700 flex items-center"
                onClick={goBack}
              >
                <FaChevronLeft className="text-sm" />
              </button>
            )}
            <h2 className="text-xl font-bold">
              {type === null
                ? "Select store type"
                : `Add new ${type === "Chef" ? "chef" : "seller"}`}
            </h2>
            <button
              className="text-gray-400 hover:text-gray-600 text-xl leading-none"
              onClick={() => setShow(false)}
            >
  ×
            </button>
          </div>

          {type !== null && (
            <div className="flex items-center justify-center gap-2 pt-4 shrink-0">
              <span
                className={`h-2 w-8 rounded-full ${step === 1 ? "bg-firstColor-shade4" : "bg-gray-200"}`}
              />
              <span
                className={`h-2 w-8 rounded-full ${step === 2 ? "bg-firstColor-shade4" : "bg-gray-200"}`}
              />
            </div>
          )}

          <div className="px-6 py-5 overflow-y-auto flex-1">
            {type === null && (
              <div className="flex flex-col gap-4 items-center py-6">
                <button
                  className="w-full max-w-xs p-3 rounded-lg bg-firstColor-shade4 text-white hover:opacity-90"
                  onClick={() => setType("Seller")}
                >
                  Grocery Store
                </button>
                <button
                  className="w-full max-w-xs p-3 rounded-lg bg-firstColor-shade4 text-white hover:opacity-90"
                  onClick={() => setType("Chef")}
                >
                  Homemade Foods
                </button>
              </div>
            )}

            {type !== null && step === 1 && (
              <div className="grid grid-cols-2 md:grid-cols-1 gap-x-6 gap-y-4 text-gray-500">
                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    User Name *
                  </label>
                  <input
                    required
                    placeholder="Enter User Name"
                    className={`w-full p-2 border rounded-lg ${errors.userName ? "border-red-500" : ""}`}
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Phone Number *
                  </label>
                  <input
                    required
                    placeholder="Enter Phone Number"
                    className={`w-full p-2 border rounded-lg ${errors.mobile ? "border-red-500" : ""}`}
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Email *
                  </label>
                  <input
                    required
                    type="email"
                    placeholder="Enter Email Address"
                    className={`w-full p-2 border rounded-lg ${errors.email ? "border-red-500" : ""}`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Date of Birth *
                  </label>
                  <input
                    required
                    type="date"
                    className={`w-full p-2 border rounded-lg ${errors.birthday ? "border-red-500" : ""}`}
                    value={birthday}
                    onChange={(e) => setBirthday(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Address *
                  </label>
                  <input
                    required
                    placeholder="Enter Address"
                    className={`w-full p-2 border rounded-lg ${errors.address ? "border-red-500" : ""}`}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Password *
                  </label>
                  <input
                    required
                    placeholder="Enter Password"
                    className={`w-full p-2 border rounded-lg ${errors.password ? "border-red-500" : ""}`}
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

               
              </div>
            )}

            {type !== null && step === 2 && (
              <div className="flex flex-col gap-4 text-gray-500">
                <div className="relative">
                  <label className="block mb-1 text-left text-sm font-medium">
                    Immigration Status *
                  </label>
                  <button
                    type="button"
                    onClick={() => setOpenImmigration((prev) => !prev)}
                    className={`w-full p-2 border rounded-lg bg-white flex justify-between items-center ${errors.immigrationStatus ? "border-red-500" : ""}`}
                  >
                    <span
                      className={
                        immigrationStatus ? "text-black" : "text-gray-400"
                      }
                    >
                      {loadingStatus
                        ? "Loading..."
                        : mainStatusList.find(
                            (opt) => opt.value === immigrationStatus,
                          )?.label || "Select immigration status"}
                    </span>
                    <MdKeyboardArrowDown className="ml-2 h-5 text-gray-500" />
                  </button>

                  {openImmigration && (
                    <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-30 text-left">
                      {mainStatusList.map((option) => (
                        <li
                          key={option.key}
                          onClick={() => {
                            setImmigrationStatusValue(option.value);
                            if (option.value !== "temporary") setTrType("");
                            setOpenImmigration(false);
                          }}
                          className="py-2 px-4 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {immigrationStatus === "temporary" && (
                  <div className="relative">
                    <label className="block mb-1 text-left text-sm font-medium">
                      TR Type *
                    </label>
                    <button
                      type="button"
                      onClick={() => setOpenTrType((prev) => !prev)}
                      className={`w-full p-2 border rounded-lg bg-white flex justify-between items-center ${errors.trType ? "border-red-500" : ""}`}
                    >
                      <span className={trType ? "text-black" : "text-gray-400"}>
                        {trTypeList.find((opt) => opt.value === trType)
                          ?.label || "Select TR type"}
                      </span>
                      <MdKeyboardArrowDown className="ml-2 h-5 text-gray-500" />
                    </button>

                    {openTrType && (
                      <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-30 text-left">
                        {trTypeList.map((option) => (
                          <li
                            key={option.key}
                            onClick={() => {
                              setTrType(option.value);
                              setOpenTrType(false);
                            }}
                            className="py-2 px-4 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Bank Account Number *
                  </label>
                  <input
                    required
                    type="text"
                    inputMode="numeric"
                    maxLength={16}
                    placeholder="16-digit account number"
                    className={`w-full p-2 border rounded-lg ${errors.bankAccountNumber ? "border-red-500" : ""}`}
                    value={bankAccountNumber}
                    onChange={(e) =>
                      setBankAccountNumber(e.target.value.replace(/\D/g, ""))
                    }
                  />
                </div>

                <div>
                  <label className="block mb-1 text-left text-sm font-medium">
                    Immigration Document *
                  </label>
                  <div
                    onClick={() => immigrationDocRef.current.click()}
                    className={`w-full h-28 rounded-lg border-2 border-dashed flex flex-col items-center justify-center cursor-pointer text-neutral-400 ${errors.immigrationDocument ? "border-red-500" : "border-neutral-400"}`}
                  >
                    <BsImage className="text-3xl mb-2" />
                    <span>
                      {uploadingImage
                        ? "Uploading..."
                        : documentName || "Upload immigration document"}
                    </span>
                    <input
                      ref={immigrationDocRef}
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setDocumentName(file.name);
                          uploadImage(file);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {type !== null && (
            <div className="flex justify-center items-center gap-5 px-6 py-4 border-t border-gray-200 shrink-0">
              {step === 1 && (
                <button
                  className="px-6 py-2 rounded-lg bg-firstColor-shade4 text-white hover:opacity-90"
                  onClick={() => {
                    if (validateStep1()) setStep(2);
                  }}
                >
                  Next
                </button>
              )}

              {step === 2 && (
                <button
                  className="px-6 py-2 rounded-lg bg-firstColor-shade4 text-white hover:opacity-90 flex items-center justify-center min-w-28"
                  onClick={CreateUser}
                  disabled={loadingCreate}
                >
                  {loadingCreate ? (
                    <Loading textColor="white-0" />
                  ) : (
                    `Create ${type === "Chef" ? "Chef" : "Seller"}`
                  )}
                </button>
              )}

              <button
                className="hover:bg-gray-100 border-2 px-4 py-2 rounded-lg"
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}